/* Local presentation only: the installed Globo form owns all booking behavior. */
if (!customElements.get('asif-spirits-body')) {
  customElements.define('asif-spirits-body', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.dialog = this.querySelector('dialog');
      const view = this.querySelector('[data-spirits-photo-view]');
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-spirits-photo]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !this.dialog?.showModal) return;
        event.preventDefault();
        this.opener = link;
        const title = this.querySelector('[data-spirits-photo-title]');
        if (title) title.textContent = link.dataset.photoTitle || link.querySelector('img')?.alt || ''; 
        const photo = link.querySelector('img').cloneNode();
        photo.removeAttribute('srcset'); photo.removeAttribute('sizes');
        photo.loading = 'eager'; photo.src = link.href;
        view.replaceChildren(photo); this.dialog.showModal();
        this.querySelector('[data-spirits-photo-close]').focus();
      }, { signal });
      this.querySelector('[data-spirits-photo-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog?.addEventListener('close', () => {
        view.replaceChildren();
        if (this.opener?.isConnected) this.opener.focus({ preventScroll:true });
      }, { signal });
      const compactLabels = new Map([
        ['Mit wie vielen Personen planst du?', 'Wie viele seid ihr?'],
        ['Teamevent (z. B. Firmenfeier, Team-Building, Business-Event)', 'Teamevent / Firmenfeier'],
        ['Geburtstag (Feier mit Freunden & Familie)', 'Geburtstag'],
        ['Junggesellenabschied (JGA) (Für Braut oder Bräutigam)', 'Junggesellenabschied (JGA)'],
        ['Einfach so (Weil Cocktails Spaß machen!)', 'Einfach so'],
        ['Weihnachtsfeier (Perfekt für den Jahresabschluss mit Kollegen oder Freunden)', 'Weihnachtsfeier'],
        ['After-Work-Event (Entspannter Abend nach der Arbeit)', 'After-Work-Event'],
        ['Networking-Event (Business & Drinks in entspannter Atmosphäre)', 'Networking-Event'],
        ['Vereins- oder Gruppen-Event (Sportmannschaften, Kegelclubs, Freundeskreise)', 'Vereins- oder Gruppen-Event'],
        ['Kundenevent (Cocktailkurs als exklusives Erlebnis für Geschäftspartner)', 'Kundenevent'],
        ['Wir planen etwas anderes', 'Anderer Anlass']
      ]);
      const formShell = this.querySelector('[data-spirits-form-shell]');
      this.updateLabels = () => {
        formShell?.querySelectorAll('.heading-title').forEach(heading => {
          if (heading.textContent.trim() === 'Deine Kurs Anfrage' && this.dataset.formHeading && heading.textContent !== this.dataset.formHeading) heading.textContent = this.dataset.formHeading;
          if (heading.textContent.trim() === 'Nur noch ein Schritt' && this.dataset.contactHeading && heading.textContent !== this.dataset.contactHeading) heading.textContent = this.dataset.contactHeading;
        });
        formShell?.querySelectorAll('.heading-caption').forEach(caption => {
          if (caption.textContent.trim() === 'Nach dem Absenden geht es ganz schnell und wir schicken dir dein komplett unverbindliches Angebot zu.' && this.dataset.contactCopy && caption.textContent !== this.dataset.contactCopy) caption.textContent = this.dataset.contactCopy;
        });
        const fieldLabels = new Map([['Nachnahme', this.dataset.lastName], ['Email', this.dataset.emailLabel]]);
        formShell?.querySelectorAll('.label-content').forEach(label => {
          const next = fieldLabels.get(label.textContent.trim());
          if (next && label.textContent !== next) label.textContent = next;
        });
        formShell?.querySelectorAll('input[placeholder]').forEach(input => {
          const next = fieldLabels.get(input.placeholder);
          if (next && input.placeholder !== next) input.placeholder = next;
        });
        const active = formShell?.querySelector('.panel.movingIn')?.dataset.step;
        const steps = formShell?.querySelector('.wizard__steps .steps');
        if (steps) steps.setAttribute('aria-label', this.dataset.progressLabel);
        formShell?.querySelectorAll('.wizard__steps .step').forEach(step => {
          const label = step.dataset.step === '0' ? this.dataset.stepOne : this.dataset.stepTwo;
          const number = step.querySelector('.step__number');
          if (number && number.textContent !== label) number.textContent = label;
          if (step.dataset.step === active) step.setAttribute('aria-current','step');
          else step.removeAttribute('aria-current');
        });
        formShell?.querySelectorAll('select option').forEach(option => {
        if (!option.hasAttribute('value')) return; // Text must never become a different submitted value.
        if (!option.dataset.asifFullLabel) option.dataset.asifFullLabel = option.textContent.trim();
        const full = option.dataset.asifFullLabel;
        const next = compactLabels.get(full) || full;
        if (option.textContent !== next) option.textContent = next;
        });
      };
      this.updateLabels();
      this.observer = new MutationObserver(this.updateLabels);
      if (formShell) this.observer.observe(formShell, { childList:true, subtree:true, attributes:true, attributeFilter:['class'] });
    }
    disconnectedCallback() {
      this.dialog?.close(); this.abort?.abort(); this.observer?.disconnect();
    }
  });
}
